module.exports = __webpack_public_path__ + "img/icon_wuxingbi_money.160617a9.png";